import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import {
  hasAuthSession,
  subscribeAuthChanges,
} from "../auth/authStorage";

const PrivateRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(hasAuthSession());

  useEffect(() => {
    return subscribeAuthChanges(() => {
      setIsAuthenticated(hasAuthSession());
    });
  }, []);

  return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
